import store from 'Shared/store'
import { Provider } from 'react-redux'
import './Analytics.scoped.scss'
import Filters from './shared/Filters'
import Tabs from 'Shared/components/Tabs/Tabs'
import DateRangeSelect from './shared/DateRangeSelect'
import { format, parse, formatISO, parseISO, addDays } from 'date-fns'
import AnalyticsQuery from './AnalyticsQuery'
import NewAnalytics from './NewAnalytics'

const Analytics = () => {
  if ((new URLSearchParams(window.location.search)).get('newView') === '1') {
    return <NewAnalytics />
  }

  return (
    <Provider store={store}>
      <AnalyticsInner />
    </Provider>
  )
}

function AnalyticsInner() {
  const [screen, setScreen] = useState('calls')
  const dateRange = useSel((s) => s.analytics.dateRange)
  const rules = useSel(s => _.values(s.rules.entities))

  const formattedDateRange = {
    // parse like 2025-6-23
    from: dateRange.from ? formatISO(parse(dateRange.from, 'yyyy-MM-dd', new Date())) : '',
    to: dateRange.to ? formatISO(addDays(parse(dateRange.to, 'yyyy-MM-dd', new Date()), 1)) : ''
  }

  const tabs = [
    { text: 'Calling', key: 'calls', current: screen === 'calls' },
    { text: 'Texting', key: 'text_messages', current: screen === 'text_messages' },
    { text: 'Emails', key: 'emails', current: screen === 'emails' },
  ]

  let defaultFilterValues = [{ id: 'time', value: formattedDateRange }]
  if (rules.length > 0) {
    defaultFilterValues.push({ id: 'rules_filter', value: rules })
  }

  return <>
    <div className="sectionn tabs-and-filters">
      <Tabs tabs={tabs} onChange={setScreen} />
      <div>
        <DateRangeSelect />
      </div>
    </div>
    <Filters />
    <AnalyticsQuery
      key={screen}
      kind={screen}
      defaultChartType='simpleAnalyticsView'
      filtersEnabled={false}
      segmentsEnabled={false}
      viewsEnabled={false}
      defaultFilterValues={defaultFilterValues}
    />
  </>
}

export default Analytics
